var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('div', [_c('v-row', [_c('v-col', [_c('div', {
    staticClass: "order-content"
  }, [_c('v-card', {
    staticClass: "px-12px py-20px pa-md-50px",
    attrs: {
      "tile": "",
      "elevation": "0"
    }
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--unberline"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("주문하기")])]), _c('section', {
    staticClass: "page-section pt-0"
  }, [_c('div', {
    staticClass: "mb-10px mb-md-20px"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("구매자 정보 입력")]), _c('v-divider', {
    staticClass: "grey lighten-1 mt-10px"
  })], 1), _c('div', [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "이름",
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.order.buyer.name,
      callback: function callback($$v) {
        _vm.$set(_vm.order.buyer, "name", $$v);
      },
      expression: "order.buyer.name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "w-100 mw-500px"
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-select', _vm._b({
    attrs: {
      "items": _vm.phones,
      "placeholder": "연락처",
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.order.buyer.phone1,
      callback: function callback($$v) {
        _vm.$set(_vm.order.buyer, "phone1", $$v);
      },
      expression: "order.buyer.phone1"
    }
  }, 'v-select', _vm.$attrs, false))], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "outlined": "",
      "hide-details": "",
      "maxlength": "4"
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.kcpCert.open();
      }
    },
    model: {
      value: _vm.order.buyer.phone2,
      callback: function callback($$v) {
        _vm.$set(_vm.order.buyer, "phone2", $$v);
      },
      expression: "order.buyer.phone2"
    }
  }, 'v-text-field', _vm.$attrs, false))], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "outlined": "",
      "hide-details": "",
      "maxlength": "4"
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.kcpCert.open();
      }
    },
    model: {
      value: _vm.order.buyer.phone3,
      callback: function callback($$v) {
        _vm.$set(_vm.order.buyer, "phone3", $$v);
      },
      expression: "order.buyer.phone3"
    }
  }, 'v-text-field', _vm.$attrs, false))], 1)], 1)], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "이메일",
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.order.buyer.email,
      callback: function callback($$v) {
        _vm.$set(_vm.order.buyer, "email", $$v);
      },
      expression: "order.buyer.email"
    }
  })], 1)], 1)], 1)]), !_vm.carts.find(function (cart) {
    return cart.product.type == "ebook";
  }) ? [_c('section', {
    staticClass: "page-section"
  }, [_c('div', {
    staticClass: "mb-10px mb-md-20px"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("수취인 정보 입력")]), _c('v-divider', {
    staticClass: "grey lighten-1 mt-10px"
  })], 1), _c('div', [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "이름",
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.order.receiver.name,
      callback: function callback($$v) {
        _vm.$set(_vm.order.receiver, "name", $$v);
      },
      expression: "order.receiver.name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "w-100 mw-500px"
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-select', _vm._b({
    attrs: {
      "items": _vm.phones,
      "placeholder": "연락처",
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.kcpCert.open();
      }
    },
    model: {
      value: _vm.order.receiver.phone1,
      callback: function callback($$v) {
        _vm.$set(_vm.order.receiver, "phone1", $$v);
      },
      expression: "order.receiver.phone1"
    }
  }, 'v-select', _vm.$attrs, false))], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "outlined": "",
      "hide-details": "",
      "maxlength": "4"
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.kcpCert.open();
      }
    },
    model: {
      value: _vm.order.receiver.phone2,
      callback: function callback($$v) {
        _vm.$set(_vm.order.receiver, "phone2", $$v);
      },
      expression: "order.receiver.phone2"
    }
  }, 'v-text-field', _vm.$attrs, false))], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "outlined": "",
      "hide-details": "",
      "maxlength": "4"
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.kcpCert.open();
      }
    },
    model: {
      value: _vm.order.receiver.phone3,
      callback: function callback($$v) {
        _vm.$set(_vm.order.receiver, "phone3", $$v);
      },
      expression: "order.receiver.phone3"
    }
  }, 'v-text-field', _vm.$attrs, false))], 1)], 1)], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "이메일",
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.order.receiver.email,
      callback: function callback($$v) {
        _vm.$set(_vm.order.receiver, "email", $$v);
      },
      expression: "order.receiver.email"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "w-100 mw-500px"
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "placeholder": "우편번호",
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": "",
      "readonly": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.daumPostcode.open();
      }
    },
    model: {
      value: _vm.order.shippingAddress.postcode,
      callback: function callback($$v) {
        _vm.$set(_vm.order.shippingAddress, "postcode", $$v);
      },
      expression: "order.shippingAddress.postcode"
    }
  }, 'v-text-field', _vm.$attrs, false))], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "v-btn--input",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.daumPostcode.open();
      }
    }
  }, [_vm._v("주소검색")])], 1)], 1)], 1)]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "placeholder": "기본주소",
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": "",
      "readonly": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.daumPostcode.open();
      }
    },
    model: {
      value: _vm.order.shippingAddress.address1,
      callback: function callback($$v) {
        _vm.$set(_vm.order.shippingAddress, "address1", $$v);
      },
      expression: "order.shippingAddress.address1"
    }
  }, 'v-text-field', _vm.$attrs, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "placeholder": "상세주소",
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.order.shippingAddress.address2,
      callback: function callback($$v) {
        _vm.$set(_vm.order.shippingAddress, "address2", $$v);
      },
      expression: "order.shippingAddress.address2"
    }
  }, 'v-text-field', _vm.$attrs, false))], 1)], 1)], 1)]), _c('section', {
    staticClass: "page-section pt-0"
  }, [_c('v-checkbox', {
    staticClass: "d-inline-flex ma-0",
    attrs: {
      "label": "구매자 정보와 동일",
      "hide-details": ""
    },
    model: {
      value: _vm.checkbox,
      callback: function callback($$v) {
        _vm.checkbox = $$v;
      },
      expression: "checkbox"
    }
  })], 1)] : _vm._e(), _c('section', {
    staticClass: "page-section"
  }, [_c('div', {
    staticClass: "mb-10px mb-md-20px"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("요청사항")]), _c('v-divider', {
    staticClass: "grey lighten-1 mt-10px"
  })], 1), _c('v-textarea', {
    attrs: {
      "placeholder": "배송요청사항",
      "outlined": "",
      "persistent-placeholder": "",
      "rows": "3",
      "hide-details": ""
    },
    model: {
      value: _vm.order.demand,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "demand", $$v);
      },
      expression: "order.demand"
    }
  })], 1), _c('section', {
    staticClass: "page-section"
  }, [_c('v-divider', {
    staticClass: "grey darken-4"
  }), _vm._l(_vm.carts, function (cart, index) {
    return [index ? _c('v-divider') : _vm._e(), _c('pickup-item', {
      key: cart._id,
      attrs: {
        "cart": cart
      }
    })];
  }), _c('v-divider')], 2), _vm.me ? _c('section', {
    staticClass: "page-section"
  }, [_c('div', {
    staticClass: "mb-10px mb-md-20px"
  }, [_c('h3', {
    staticClass: "d-flex flex-wrap align-center tit tit--xs"
  }, [_c('span', {
    staticClass: "mr-8px"
  }, [_vm._v("포인트")]), _c('span', {
    staticClass: "font-size-14 font-weight-regular"
  }, [_vm._v("(포인트는 500원부터 사용이 가능합니다)")])]), _c('v-divider', {
    staticClass: "grey lighten-1 mt-10px"
  })], 1), _c('div', [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "d-inline-flex align-center font-size-14 line-height-1"
  }, [_c('span', {
    staticClass: "mr-8px"
  }, [_vm._v("보유포인트")]), _c('b', {
    staticClass: "font-size-18 font-size-md-22"
  }, [_vm._v(_vm._s(_vm.me.point.format()))]), _c('span', {
    staticClass: "ml-2px"
  }, [_vm._v("원")])])]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "포인트 사용",
      "suffix": "원",
      "persistent-placeholder": "",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": function input(value) {
        return _vm.$nextTick(function (_) {
          return _vm.changePoint(value);
        });
      }
    },
    model: {
      value: _vm.order.pointAmount,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "pointAmount", $$v);
      },
      expression: "order.pointAmount"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "v-btn--input",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.usePoint
    }
  }, [_vm._v("전체사용")])], 1)], 1)], 1)], 1)], 1)]) : _vm._e(), _vm.me ? _c('section', {
    staticClass: "page-section"
  }, [_c('div', {
    staticClass: "mb-10px mb-md-20px"
  }, [_c('h3', {
    staticClass: "d-flex flex-wrap align-center tit tit--xs"
  }, [_c('span', {
    staticClass: "mr-8px"
  }, [_vm._v("캐시")]), _c('span', {
    staticClass: "font-size-14 font-weight-regular"
  }, [_vm._v("(캐시는 100원부터 사용이 가능합니다)")])]), _c('v-divider', {
    staticClass: "grey lighten-1 mt-10px"
  })], 1), _c('div', [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "d-inline-flex align-center font-size-14 line-height-1"
  }, [_c('span', {
    staticClass: "mr-8px"
  }, [_vm._v("보유캐시")]), _c('b', {
    staticClass: "font-size-18 font-size-md-22"
  }, [_vm._v(_vm._s(_vm.me.cash.format()))]), _c('span', {
    staticClass: "ml-2px"
  }, [_vm._v("원")])])]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "캐시 사용",
      "suffix": "원",
      "persistent-placeholder": "",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": function input(value) {
        return _vm.$nextTick(function (_) {
          return _vm.changeCash(value);
        });
      }
    },
    model: {
      value: _vm.order.cashAmount,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "cashAmount", $$v);
      },
      expression: "order.cashAmount"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "v-btn--input",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.useCash
    }
  }, [_vm._v("전체사용")])], 1)], 1)], 1)], 1)], 1)]) : _vm._e(), _c('section', {
    staticClass: "page-section pb-0"
  }, [_c('div', {
    staticClass: "mb-10px mb-md-20px"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("결제방법")]), _c('v-divider', {
    staticClass: "grey lighten-1 mt-10px"
  })], 1), _c('div', [_c('div', {
    staticClass: "d-inline-flex flex-wrap align-center font-size-14 line-height-1"
  }, [_c('v-checkbox', {
    staticClass: "ma-0",
    attrs: {
      "value": true,
      "hide-details": "",
      "label": "신용카드"
    },
    model: {
      value: _vm.cardCheck,
      callback: function callback($$v) {
        _vm.cardCheck = $$v;
      },
      expression: "cardCheck"
    }
  }), _c('span', {
    staticClass: "font-size-14 line-height-14 ml-6px"
  }, [_vm._v("(나누리 캐시 또는 포인트 사용시 결제 금액 입력후 신용카드 선택 결제 할 수 있습니다.)")])], 1)])]), _vm.cashbill ? _c('section', {
    staticClass: "page-section pb-0"
  }, [_c('div', {
    staticClass: "mb-10px mb-md-20px"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("현금영수증"), _c('v-icon', {
    on: {
      "click": function click($event) {
        return _vm.$refs.cashbillInfo.open();
      }
    }
  }, [_vm._v("mdi-help-circle")])], 1), _c('v-divider', {
    staticClass: "grey lighten-1 mt-10px"
  })], 1), _c('div', [_c('div', {
    staticClass: "d-inline-flex flex-wrap align-center font-size-14 line-height-1"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', [_c('v-col', [_c('v-checkbox', {
    staticClass: "ma-0",
    attrs: {
      "value": true,
      "hide-details": "",
      "label": "현금영수증 신청"
    },
    model: {
      value: _vm.order.cashbill.status,
      callback: function callback($$v) {
        _vm.$set(_vm.order.cashbill, "status", $$v);
      },
      expression: "order.cashbill.status"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-radio-group', {
    attrs: {
      "disabled": !_vm.order.cashbill.status
    },
    model: {
      value: _vm.order.cashbill.tradeUsage,
      callback: function callback($$v) {
        _vm.$set(_vm.order.cashbill, "tradeUsage", $$v);
      },
      expression: "order.cashbill.tradeUsage"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "개인 소득 공제",
      "value": "소득공제용"
    }
  }), _c('v-radio', {
    attrs: {
      "label": "사업자 지출 증빙",
      "value": "지출증빙용"
    }
  })], 1), _vm.order.cashbill.tradeUsage === '소득공제용' ? _c('v-select', {
    attrs: {
      "disabled": !_vm.order.cashbill.status,
      "items": _vm.items,
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.cashbillType,
      callback: function callback($$v) {
        _vm.cashbillType = $$v;
      },
      expression: "cashbillType"
    }
  }) : _vm._e(), _c('v-text-field', {
    attrs: {
      "placeholder": _vm.displayCashbillPlaceholder,
      "disabled": !_vm.order.cashbill.status,
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.order.cashbill.identityNum,
      callback: function callback($$v) {
        _vm.$set(_vm.order.cashbill, "identityNum", $$v);
      },
      expression: "order.cashbill.identityNum"
    }
  })], 1)], 1)], 1)], 1)])]) : _vm._e()], 2), _vm.$vuetify.breakpoint.mobile ? _c('div', {
    staticClass: "card--primary mt-10px mt-md-20px"
  }, [_c('v-row', {
    staticClass: "row--x-small font-size-14 font-size-md-16",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v("총 상품가격("), _c('b', [_vm._v(_vm._s(_vm.saleAmount.format()) + "원")]), _vm._v(")")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("+")]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v("총 배송비("), _c('b', [_vm._v(_vm._s(_vm.shippingAmount.format()) + "원")]), _vm._v(")")])]), _vm.islandAmount ? _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("+")]) : _vm._e(), _vm.islandAmount ? _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v("도서산간 할증("), _c('b', [_vm._v(_vm._s(_vm.islandAmount.format()) + "원")]), _vm._v(")")])]) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v("사용 포인트("), _c('b', [_vm._v(_vm._s((+_vm.order.pointAmount).format()) + "원")]), _vm._v(")")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v("사용 캐시("), _c('b', [_vm._v(_vm._s((+_vm.order.cashAmount).format()) + "원")]), _vm._v(")")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("=")]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('span', [_vm._v("총 결제 금액")]), _c('b', {
    staticClass: "font-size-20 font-size-md-24 ml-10px ml-md-12px"
  }, [_vm._v(_vm._s(_vm.totalAmount.format()) + "원")])])])], 1)], 1) : _vm._e()], 1)]), !_vm.$vuetify.breakpoint.mobile ? _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "quick-order-wrap"
  }, [_c('v-card', {
    staticClass: "quick-order pa-12px pa-md-30px",
    attrs: {
      "tile": "",
      "elevation": "0",
      "width": "376"
    }
  }, [_c('div', {
    staticClass: "quick-order-info"
  }, [_c('div', {
    staticClass: "quick-order-info-item"
  }, [_c('v-row', {
    staticClass: "row--small font-size-14",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3",
      "md": "4"
    }
  }, [_vm._v("총 상품가격")]), _c('v-col', {
    attrs: {
      "cols": "9",
      "md": "8"
    }
  }, [_vm._v(" " + _vm._s(_vm.saleAmount.format()) + "원 ")])], 1), _c('v-row', {
    staticClass: "row--small font-size-14",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3",
      "md": "4"
    }
  }, [_vm._v("배송비")]), _c('v-col', {
    attrs: {
      "cols": "9",
      "md": "8"
    }
  }, [_vm._v(" " + _vm._s(_vm.shippingAmount.format()) + "원 ")])], 1), _vm.islandAmount ? _c('v-row', {
    staticClass: "row--small font-size-14",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3",
      "md": "4"
    }
  }, [_vm._v("도서산간 할증")]), _c('v-col', {
    attrs: {
      "cols": "9",
      "md": "8"
    }
  }, [_vm._v(" " + _vm._s(_vm.islandAmount.format()) + "원 ")])], 1) : _vm._e(), _c('v-row', {
    staticClass: "row--small font-size-14",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3",
      "md": "4"
    }
  }, [_vm._v("사용 포인트")]), _c('v-col', {
    attrs: {
      "cols": "9",
      "md": "8"
    }
  }, [_vm._v(" -" + _vm._s((+_vm.order.pointAmount).format()) + "원 ")])], 1), _c('v-row', {
    staticClass: "row--small font-size-14",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3",
      "md": "4"
    }
  }, [_vm._v("사용 캐시")]), _c('v-col', {
    attrs: {
      "cols": "9",
      "md": "8"
    }
  }, [_vm._v(" -" + _vm._s((+_vm.order.cashAmount).format()) + "원 ")])], 1)], 1), _c('div', {
    staticClass: "quick-order-info-total font-weight-medium"
  }, [_c('v-divider', {
    staticClass: "my-10px"
  }), _c('v-row', {
    staticClass: "row--small font-size-14",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3",
      "md": "4"
    }
  }, [_vm._v("총 결제금액")]), _c('v-col', {
    attrs: {
      "cols": "9",
      "md": "8"
    }
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('b', {
    staticClass: "font-size-18 font-size-md-22 secondary--text"
  }, [_vm._v(_vm._s(_vm.totalAmount.format()))]), _c('span', {
    staticClass: "ml-2px"
  }, [_vm._v("원")])])])], 1)], 1)]), _c('div', {
    staticClass: "quick-order-button mt-10px"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "block": "",
      "large": "",
      "color": "primary",
      "disabled": _vm.display
    },
    on: {
      "click": _vm.pay
    }
  }, [_vm._v("결제하기")])], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "to": "/mypage/shop/carts",
      "block": "",
      "large": "",
      "outlined": "",
      "color": "grey"
    }
  }, [_c('span', {
    staticClass: "grey--text text--darken-3"
  }, [_vm._v("장바구니")])])], 1)], 1)], 1)])], 1)]) : _vm._e()], 1)], 1), _c('div', {
    staticClass: "mt-20px mt-md-30px"
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "x-large": "",
      "color": "primary",
      "disabled": _vm.display
    },
    on: {
      "click": _vm.pay
    }
  }, [_vm._v("결제하기")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "white",
    staticStyle: {
      "border-color": "#9e9e9e!important"
    },
    attrs: {
      "x-large": "",
      "outlined": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_c('span', {
    staticClass: "grey--text text--darken-3"
  }, [_vm._v("취소하기")])])], 1)], 1)], 1), _c('daum-postcode', {
    ref: "daumPostcode",
    on: {
      "input": function input(_ref) {
        var postcode = _ref.postcode,
            address = _ref.address;
        _vm.order.shippingAddress.postcode = postcode;
        _vm.order.shippingAddress.address1 = address;
      }
    }
  }), _c('korpay', {
    ref: "korpay",
    on: {
      "complete": function complete(payload) {
        return _vm.$router.push({
          path: "/shop/result",
          query: payload
        });
      }
    }
  }), _c('cashbill-info-dialog', {
    ref: "cashbillInfo"
  }), _c('income-deduction-dialog', {
    ref: "incomeDeduction"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }